import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

interface AuthRoute {
  component: React.ComponentType<any>;
}

const AuthRoute: React.FC<AuthRoute> = ({ component: Component }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoggedIn } = useSelector((state: any) => state.auth);

  useEffect(() => {
    if (!isLoggedIn) {
      const redirectTo = location ? location.pathname : "/";

      navigate("/login", {
        state: { redirectTo: redirectTo },
      });
    }
  }, [isLoggedIn]);

  return <Component />;
};

export default AuthRoute;
